import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'kt-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit, AfterViewInit {

  
  @ViewChild('myIframe', {static: true}) iframe!: ElementRef<HTMLIFrameElement>;
  iframeSrc: string | null = null; // Başlangıçta iframe yüklenmiyor


  constructor(
    public sanitiser: DomSanitizer
  ) { }

  ngOnInit() {
  }
  ngAfterViewInit() {

  }
 

  
  loadIframe() {
    this.iframeSrc = "http://192.168.100.242:3000/embed/dashboard/eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJyZXNvdXJjZSI6eyJkYXNoYm9hcmQiOjJ9LCJwYXJhbXMiOnt9LCJleHAiOjE3NDM1OTEwMTQuNjM3NDU1Mn0.RPO6ABHRHvLr4GWb5ZxAQpmsNuyJZZEUrE7qpkJ_6Uc#bordered=false&titled=false";


    // onload olayını dinleyerek iframe yüklendiğinde işlem yapacağız
    setTimeout(() => {
      alert("1");
      if (this.iframe.nativeElement) {
        alert("2");
        console.log("doc",this.iframe.nativeElement.contentDocument);
        this.iframe.nativeElement.onload = () => {
          alert("fram load")
          this.modifyIframeContent();
        };
      }
    }, 2500); // Küçük bir gecikme ekleyerek iframe'in tam atanmasını sağlıyoruz
  }

  modifyIframeContent() {
    const iframeDoc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow.document;
    if (iframeDoc) {
      // Örneğin, belirli bir ID'ye sahip öğeyi kaldır
      const unwantedElement = iframeDoc.getElementById('remove-this');
      if (unwantedElement) {
        unwantedElement.remove();
      }

      // Örneğin, belirli bir sınıfa (class) sahip tüm öğeleri kaldır
      const unwantedNodes = iframeDoc.querySelectorAll('.___ref-label emotion-nm6fqu emotion-Button-label');
     
      unwantedNodes.forEach(node => node.remove());
    }
  }

 

}
